import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';

//========================|| ROUTERS ||=================//
const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

//Overview

const Overview = Loader(lazy(() => import('src/content/Login')));

const Forgotpass = Loader(lazy(() => import('src/content/ForgotPassword')));

const PasswordExpired = Loader(lazy(() => import('src/content/PasswordExpired')));

// Dashboard

const Banking = Loader(
  lazy(() => import('src/content/dashboard/Banking'))
);

// Options

const OptionPersonalLedge = Loader(lazy(() => import('src/content/options/OptionPersonalLedge')));
const AcceptOffer = Loader(lazy(() => import('src/content/options/AcceptOffer')));
const AcceptOfferDetail = Loader(lazy(() => import('src/content/options/AcceptOffer/AcceptOfferDetail')));
const ExerciseOption = Loader(lazy(() => import('src/content/options/ExerciseOption')));


// Awards

const PerformancePersonalLedger = Loader(
  lazy(() => import('src/content/awards/PerformancePersonalLedger'))
);
const ViewAward = Loader(lazy(() => import('src/content/awards/ViewAward')));
const ViewAwardDetail = Loader(
  lazy(() => import('src/content/awards/ViewAward/ViewAwardDetail'))
);

// accounts

const ChangePassword = Loader(
  lazy(() => import('src/content/Accounts/ChangePassword'))
);
const Profile = Loader(
  lazy(() => import('src/content/Accounts/Profile'))
);
const RegisterMFA = Loader(
  lazy(() => import('src/content/Accounts/RegisterMFA'))
);
const VerifyMFA = Loader(
  lazy(() => import('src/content/Accounts/VerifyMFA'))
);

//Administrator
//ESOP-Grant
const CreateGrant = Loader(
  lazy(() => import('src/content/Administrator/EsopGrant/CreateGrant'))
);
const MaintainGrant = Loader(
  lazy(() => import('src/content/Administrator/EsopGrant/MaintainGrant'))
);
const SendGrant = Loader(
  lazy(() => import('src/content/Administrator/EsopGrant/SendGrant'))
);
const GenerateOffer = Loader(
  lazy(() => import('src/content/Administrator/EsopGrant/GenerateOffer'))
);
const ManualAcceptance = Loader(
  lazy(() => import('src/content/Administrator/EsopGrant/ManualAcceptance'))
);
//ESOP-Option
const UploadGrant = Loader(
  lazy(() => import('src/content/Administrator/EsopUpload/UploadGrant'))
);
//ESOP-Grant
const BlackoutPeriod = Loader(
  lazy(() => import('src/content/Administrator/EsopOption/BlackoutPeriod'))
);
const ManualExcercise = Loader(
  lazy(() => import('src/content/Administrator/EsopOption/ManualExcercise'))
);
const EnterPayment = Loader(
  lazy(() => import('src/content/Administrator/EsopOption/EnterPayment'))
);
const ExcerciseProcess = Loader(
  lazy(() => import('src/content/Administrator/EsopOption/ExcerciseProcess'))
);
const AssetValue = Loader(
  lazy(() => import('src/content/Administrator/EsopOption/AssetValue'))
);
//ESOP-Approve
const ApproveGrant = Loader(
  lazy(() => import('src/content/Administrator/EsopApproval/ApproveGrant'))
);
const ApproveRetention = Loader(
  lazy(() => import('src/content/Administrator/EsopApproval/ApproveRetention'))
);
//PSP-Award
const CreateAward = Loader(
  lazy(() => import('src/content/Administrator/PspAward/CreateAward'))
);
const MaintainAward = Loader(
  lazy(() => import('src/content/Administrator/PspAward/MaintainAward'))
);
const SendAward = Loader(
  lazy(() => import('src/content/Administrator/PspAward/SendAward'))
);
const GenerateAward = Loader(
  lazy(() => import('src/content/Administrator/PspAward/GenerateAward'))
);
const AwardFactor = Loader(
  lazy(() => import('src/content/Administrator/PspAward/AwardFactor'))
);
//PSP-Upload
const UploadAward = Loader(
  lazy(() => import('src/content/Administrator/PspUpload/UploadAward'))
);
//PSP-Share
const CreditingProcess = Loader(
  lazy(() => import('src/content/Administrator/PspShare/CreditingProcess'))
);
const CreditingDate = Loader(
  lazy(() => import('src/content/Administrator/PspShare/CreditingDate'))
);
const PaymentDate = Loader(
  lazy(() => import('src/content/Administrator/PspShare/PaymentDate'))
);
//PSP-Approval
const ApproveAward = Loader(
  lazy(() => import('src/content/Administrator/PspApproval/ApproveAward'))
);
const PspApproveRetention = Loader(
  lazy(() => import('src/content/Administrator/PspApproval/ApproveRetention'))
);
//System
const UploadProfile = Loader(
  lazy(() => import('src/content/Administrator/System/UploadProfile'))
);
const ManageProfile = Loader(
  lazy(() => import('src/content/Administrator/System/ManageProfile'))
);
const NewProfile = Loader(
  lazy(() => import('src/content/Administrator/System/NewUser'))
);
const ManageLookup = Loader(
  lazy(() => import('src/content/Administrator/System/ManageLookup'))
);


//Reports

const EsopPersonalLedger = Loader(
  lazy(() => import('src/content/Reports/EsopPersonalLedger'))
);
const PspPersonalLedger = Loader(
  lazy(() => import('src/content/Reports/PspPersonalLedger'))
);
const EsopGrantOffer = Loader(
  lazy(() => import('src/content/Reports/EsopGrantOffer'))
);
const EsopGrantSummary = Loader(
  lazy(() => import('src/content/Reports/EsopGrantSummary'))
);
const EsopMasterOption = Loader(
  lazy(() => import('src/content/Reports/EsopMasterOption'))
);
const EsopExcercise = Loader(
  lazy(() => import('src/content/Reports/EsopExcercise'))
);
const EsopExpense = Loader(
  lazy(() => import('src/content/Reports/EsopExpense'))
);
const PspMasterShare = Loader(
  lazy(() => import('src/content/Reports/PspMasterShare'))
);
const PspAwardSummary = Loader(
  lazy(() => import('src/content/Reports/PspAwardSummary'))
);
const PspVesting = Loader(
  lazy(() => import('src/content/Reports/PspVesting'))
);
const PspAllotment = Loader(
  lazy(() => import('src/content/Reports/PspAllotment'))
);
const PspExpense = Loader(
  lazy(() => import('src/content/Reports/PspExpense'))
);
const UserDetails = Loader(
  lazy(() => import('src/content/Reports/UserDetails'))
);
const Lapse = Loader(
  lazy(() => import('src/content/Reports/Lapse'))
);
const Gains = Loader(
  lazy(() => import('src/content/Reports/Gains'))
);

//Help

const ContactUs = Loader(
  lazy(() => import('src/content/help/ContactUs'))
);
const PlanRules = Loader(
  lazy(() => import('src/content/help/PlanRules'))
);

// Status

const Status404 = Loader(
  lazy(() => import('src/content/Status/Status404'))
);
const Status500 = Loader(
  lazy(() => import('src/content/Status/Status500'))
);
const StatusComingSoon = Loader(
  lazy(() => import('src/content/Status/ComingSoon'))
);
const StatusMaintenance = Loader(
  lazy(() => import('src/content/Status/Maintenance'))
);

const routes: RouteObject[] = [
  {
    path: '',
    element: <BaseLayout />,
    children: [
      {
        path: '/',
        element: <Overview />
      },
      {
        path: 'forgotpasswrd',
        element: <Forgotpass />
      },
      {
        path: 'passwordexpired',
        element: <PasswordExpired />
      },
      {
        path: 'overview',
        element: <Navigate to="/" replace />
      },
      {
        path: 'status',
        children: [
          {
            path: '',
            element: <Navigate to="404" replace />
          },
          {
            path: '404',
            element: <Status404 />
          },
          {
            path: '500',
            element: <Status500 />
          },
          {
            path: 'maintenance',
            element: <StatusMaintenance />
          },
          {
            path: 'coming-soon',
            element: <StatusComingSoon />
          }
        ]
      },
      {
        path: '*',
        element: <Status404 />
      }
    ]
  },
  {
    path: 'dashboard',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="banking" replace />
      },
      {
        path: 'banking',
        element: <Banking />
      }
    ]
  },
  {
    path: 'options',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="personalLedger" replace />
      },
      {
        path: 'personalLedger',
        element: <OptionPersonalLedge />
      },
      {
        path: 'acceptOffer',
        element: <AcceptOffer />,
        children: [
          {
            path: '',
            element: <Navigate to="detail" replace />
          },
          {
            path: 'detail',
            element: <AcceptOfferDetail />
          }
        ]
      },
      {
        path:'exerciseOption',
        element:<ExerciseOption/>
      },
      
    ]
  },
  {
    path: 'awards',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="personalLedger" replace />
      },
      {
        path: 'personalLedger',
        element: <PerformancePersonalLedger />
      },
      {
        path: 'viewAward',
        element: <ViewAward />,
        children: [
          {
            path: '',
            element: <Navigate to="detail" replace />
          },
          {
            path: 'detail',
            element: <ViewAwardDetail />
          }
        ]
      }
    ]
  },
  { 
    path: 'accounts',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="profile" replace />
      },
      {
        path: 'profile',
        element: <Profile />
      },
      {
        path: 'changePassword',
        element: <ChangePassword/>
      },
      {
        path: 'RegisterMFA',
        element: <RegisterMFA/>
      },
      {
        path: 'VerifyMFA',
        element: <VerifyMFA/>
      }
    ]
  },
  {
    path: 'help',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="contactUs" replace />
      },
      {
        path: 'contactUs',
        element: <ContactUs />
      },
      {
        path: 'planRules',
        element: <PlanRules/>
      }
    ]
  },
  {
    path: 'Administrator',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="EsopGrant/createGrant" replace />
      },
      {
        path: 'EsopGrant/createGrant',
        element: <CreateGrant />
      },
      {
        path: 'EsopGrant/maintainGrant',
        element: <MaintainGrant/>
      },
      {
        path: 'EsopGrant/sendGrant',
        element: <SendGrant />
      },
      {
        path: 'EsopGrant/generateOffer',
        element: <GenerateOffer/>
      },
      {
        path: 'EsopGrant/manualAcceptance',
        element: <ManualAcceptance />
      },
      {
        path: 'EsopUpload/uploadGrant',
        element: <UploadGrant />
      },
      {
        path: 'EsopOption/blackoutPeriod',
        element: <BlackoutPeriod />
      },
      {
        path: 'EsopOption/manualExercise',
        element: <ManualExcercise/>
      },
      {
        path: 'EsopOption/enterPayment',
        element: <EnterPayment />
      },
      {
        path: 'EsopOption/exerciseProcess',
        element: <ExcerciseProcess/>
      },
      {
        path: 'EsopOption/assetValue',
        element: <AssetValue />
      },
      {
        path: 'EsopApproval/approveGrant',
        element: <ApproveGrant/>
      },
      {
        path: 'EsopApproval/approveRetention',
        element: <ApproveRetention />
      },
      {
        path: 'PspAward/createAward',
        element: <CreateAward />
      },
      {
        path: 'PspAward/maintainAward',
        element: <MaintainAward/>
      },
      {
        path: 'PspAward/sendAward',
        element: <SendAward />
      },
      {
        path: 'PspAward/generateAward',
        element: <GenerateAward/>
      },
      {
        path: 'PspAward/awardFactor',
        element: <AwardFactor />
      },
      {
        path: 'PspUpload/uploadAward',
        element: <UploadAward />
      },
      {
        path: 'PspShare/creditingProcess',
        element: <CreditingProcess/>
      },
      {
        path: 'PspShare/creditingDate',
        element: <CreditingDate />
      },
      {
        path: 'PspShare/paymentDate',
        element: <PaymentDate />
      },
      {
        path: 'PspApproval/approveAward',
        element: <ApproveAward />
      },
      {
        path: 'PspApproval/approveRetention',
        element: <ApproveRetention />
      },
      {
        path: 'System/uploadProfile',
        element: <UploadProfile />
      },
      {
        path: 'System/manageProfile',
        element: <ManageProfile />
      },
      {
        path: 'System/newProfile',
        element: <NewProfile />
      },
      {
        path: 'System/manageLookup',
        element: <ManageLookup />
      },
    ]
  },
  {
    path: 'Reports',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="esopPersonalLedger" replace />
      },
      {
        path: 'esopPersonalLedger',
        element: <EsopPersonalLedger />
      },
      {
        path: 'pspPersonalLedger',
        element: <PspPersonalLedger/>
      },
      {
        path: 'esopGrantOffer',
        element: <EsopGrantOffer/>
      },
      {
        path: 'esopGrantSummary',
        element: <EsopGrantSummary/>
      },
      {
        path: 'esopMasterOption',
        element: <EsopMasterOption/>
      },
      {
        path: 'esopExcercise',
        element: <EsopExcercise/>
      },
      {
        path: 'esopExpense',
        element: <EsopExpense/>
      },
      {
        path: 'pspMasterShare',
        element: <PspMasterShare/>
      },
      {
        path: 'pspAwardSummary',
        element: <PspAwardSummary/>
      },
      {
        path: 'pspVesting',
        element: <PspVesting/>
      },
      {
        path: 'pspAllotment',
        element: <PspAllotment/>
      },
      {
        path: 'pspExpense',
        element: <PspExpense/>
      },
      {
        path: 'userDetails',
        element: <UserDetails/>
      },
      {
        path: 'lapse',
        element: <Lapse/>
      },
      {
        path: 'gains',
        element: <Gains/>
      },
    ]
  },
];

export default routes;
